export default {
    MODULE_SETTINGS: "Настройки",
    USERS: "Пользователи",
    USERS_VIEW: "Просмотр профилей пользователей",
    USER_EDIT: "Редактирование профилей пользователей",
    USERS_SELF_EDIT: "Редактирование своего профиля",
    USERS_DELETE: "Удаление профилей пользователей",
    ROLES: "Роли",
    ROLES_VIEW: "Просмотр ролей",
    ROLES_EDIT: "Редактирование ролей",
    ROLES_DELETE: "Удаление ролей",
    ACTION_LOG: "Журнал действий",
    ACTION_LOG_VIEW: "Просмотр журнала",
    ACTION_LOG_EDIT: "Редактирование журнала",
    WORKSPACES: "Пространства",
    WORKSPACES_VIEW: "Просмотр пространств",
    WORKSPACES_EDIT: "Редактирование пространств",
    WORKSPACES_DELETE: "Удаление пространств",
    PROJECTS: "Проекты",
    PROJECTS_VIEW: "Просмотр проектов",
    PROJECTS_EDIT: "Редактирование проектов",
    PROJECTS_DELETE: "Удаление проектов",
    DOCUMENTS: "Документы",
    DOCUMENTS_VIEW: "Просмотр документов",
    DOCUMENTS_EDIT: "Редактирование документов",
    DOCUMENTS_DELETE: "Удаление документов",
    SUMMARY_REPORTS: "Отчёты",
    SUMMARY_REPORTS_VIEW: "Просмотр отчётов",
    SUMMARY_REPORTS_EDIT: "Редактирование отчётов",
    SUMMARY_REPORTS_DELETE: "Удаление отчётов",
    METHODS: "Методы",
    METHODS_VIEW: "Просмотр методов",
    METHODS_RUN: "Запуск методов",
    TASKS: "Задания",
    TASKS_VIEW: "Просмотр заданий",
    SETTINGS: "Параметры",
    SETTINGS_VIEW: "Просмотр параметров",
    SETTINGS_EDIT: "Редактирование параметров",
    ONTOLOGICAL_MODEL: "Онтологическая модель",
    ONTOLOGICAL_MODEL_VIEW: "Просмотр онтологической модели",
    ONTOLOGICAL_MODEL_EDIT: "Редактирование онтологической модели",
    PASSWORD_POLICY: "Парольная политика",
    PASSWORD_POLICY_VIEW: "Просмотр парольной политики",
    PASSWORD_POLICY_EDIT: "Редактирование парольной политики"
};
